import React from 'react'
import ScopeTemplate from '../../components/ScopeTemplate/ScopeTemplate'

function Aerospace() {
    const overview =
        'Accelor Microsystems provides advanced electronic solutions for UAVs and unmanned aerial platforms, integrating hardware, software, and mechanical design capabilities. Our systems are engineered for precision flight operations, real-time processing, and operational reliability in dynamic environments.'

    const points = [
        'Flight control, stabilization & navigation electronics',
        'Real-time embedded software development',
        'Lightweight, high-efficiency power management systems',
        'AI/ML-based processing modules for intelligent applications',
        'System integration, validation & environmental qualification',
    ]

    const tags = [
        'Flight Control',
        'Embedded Software',
        'AI / ML',
        'System Integration',
    ]

    return (
        <ScopeTemplate
            title='AEROSPACE'
            subtitle='Electronics for UAVs & Unmanned Aerial Platforms'
            overview={overview}
            points={points}
            tags={tags}
        />
    )
}

export default Aerospace